export const defaultArea = {
  assignmentGrades: false,
  standardsReport: false,
  responseAnalysisReport: false,
};
